import {
	BlockedTimeResponse,
	BookingPreferredArea,
	BookingType,
	MakeBookingType,
	PayBookingResponse,
} from '../types/booking';

import request from './request';

export const fetchBookingByGuid = (guid: string) => {
	return request.get<BookingType>(`/${guid}`);
};

export const makeBooking = (payload: MakeBookingType) => {
	return request.post<BookingType>('/', payload);
};

export const fetchBookingAreas = (lang: string) => {
	return request.get<BookingPreferredArea[]>(`/place/areas?lang=${lang}`);
};

// @param date - Format is '2022-08-04'.
export const getBookingBlockTimes = (date?: string) => {
	return request.get<BlockedTimeResponse>(`/blocks${date ? '?date=' + date : ''}`);
};

export const cancelBooking = (guid: string) => {
	return request.put<PayBookingResponse>(`/${guid}/cancel`);
};
